// Display ratings per product slug (editable here; storefront shows these)
export const RATINGS = {
  "seven-mukhi-rudraksha": { stars: 4.5, reviews: 2278 },
  "seven-mukhi-cash-box": { stars: 5, reviews: 3152 },
  "seven-mukhi-hanging": { stars: 4.5, reviews: 2041 },
  "seven-mukhi-devi-lakshmi-bracelet": { stars: 4, reviews: 2630 },
  "778-ganesh-laxmi-bandh": { stars: 5, reviews: 3894 },
  "aarogya-maha-lakshmi-puja": { stars: 4.5, reviews: 1246 },
};

export const getRating = (slug) => RATINGS[slug] || { stars: 4.5, reviews: 2100 };
